module.exports = __webpack_public_path__ + "img/person.66b8c98d.svg";